export default Object.freeze({
    Admin: 'admin',
    Manager: 'manager',
    Employee: 'employee',
});
